import { FC, useState, useId } from 'react';
import EditorLink from 'lowcode/components/EditorLink';
import { Swiper, SwiperSlide } from 'swiper/react';
import EditorImg from 'lowcode/components/EditorImg';
import { Navigation } from 'swiper';
import styled from './index.module.scss';
import { CloseIcon, AddIcon } from '@/components/XPower/svg';

interface IProps {
    text?: string;
    mediaList: {
        pc: string;
        h5?: string;
        text: string;
    }[];
}

const MoreButton: FC<IProps> = ({ text, mediaList }) => {
    const [show, setShow] = useState(false);
    const id = useId();

    const handleShowMedia = () => {
        if (show) return;
        setShow(true);
        setTimeout(
            () =>
                document.getElementById(id)?.scrollIntoView({
                    block: 'end',
                    behavior: 'smooth',
                    inline: 'nearest',
                }),
            0,
        );
    };

    return (
        <div className={styled.MoreButton}>
            <EditorLink className={`btn ${show && 'disabled'}`} onClick={handleShowMedia}>
                <span>{text}</span>
                <span className="add">
                    <AddIcon />
                </span>
            </EditorLink>
            {mediaList.length > 0 && (
                <div className={`media_list ${show && 'show'}`} id={id}>
                    <div className="tools">
                        <span className="close" onClick={() => setShow(false)}>
                            <CloseIcon />
                        </span>
                    </div>
                    <Swiper
                        className={`media_swiper ${mediaList.length === 1 ? 'only-one' : ''}`}
                        modules={[Navigation]}
                        spaceBetween={30}
                        navigation
                        // centeredSlides={true}
                        slidesPerView={'auto'}
                        initialSlide={0}
                        scrollbar={{
                            hide: false,
                            draggable: true,
                            dragSize: 32,
                            snapOnRelease: true,
                        }}
                    >
                        {mediaList?.map((item, index) => (
                            <SwiperSlide className="item" key={index}>
                                <div className="media">
                                    <EditorImg pc={item.pc} h5={item.h5} alt={item.text} />
                                </div>
                                <p className="text">{item.text}</p>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            )}
        </div>
    );
};

export default MoreButton;
